// Import from npm package (cleaner than UMD)
import * as CookieConsent from 'vanilla-cookieconsent';

console.log('CookieConsent loaded');
// Enable dark mode
// document.documentElement.classList.add('cc--darkmode');

const runCookieConsent = () => {
  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "cloud",
        position: "bottom center",
        equalWeightButtons: true,
        flipButtons: false
      },
      preferencesModal: {
        layout: "box",
        position: "right",
        equalWeightButtons: true,
        flipButtons: false
      }
    },
    categories: {
      necessary: {
        readOnly: true
      },
      analytics: {},
      marketing: {},
      extended_marketing: {},
    },
    language: {
      default: "en",
      autoDetect: "browser",
      translations: {
        cs: {
          consentModal: {
            title: "Nastavení ochrany soukromí na našich webových stránkách",
            description: "Naše stránky používají soubory cookies, které nám pomáhají zlepšovat naše služby, personalizovat reklamy a analyzovat návštěvnost. Následující kategorie popisují, jak jsou soubory cookies používány. Pro více informací o tom, jak používáme soubory cookies, navštivte naši stránku s <a href=\"/ochrana-osobnich-udaju\">politikou ochrany soukromí</a>.",
            acceptAllBtn: "Souhlasím",
            acceptNecessaryBtn: "Přijmout pouze nezbytné",
            showPreferencesBtn: "Upravit nastavení",
            footer: "<a href=\"/ochrana-osobnich-udaju\">Zásady zpracování osobních údajů</a>"
          },
          preferencesModal: {
            title: "Nastavení soukromí",
            acceptAllBtn: "Přijmout vše",
            acceptNecessaryBtn: "Odmítnout volitelné",
            savePreferencesBtn: "Uložit nastavení",
            closeIconLabel: "Zavřít dialog",
            serviceCounterLabel: "Service|Services",
            sections: [
              {
                title: "Nezbytné <span class=\"pm__badge\">Vždy zapnuté</span>",
                description: "Tato volba zahrnuje soubory Cookies a další údaje, které jsou nezbytné pro základní funkce webových stránek, aby mohly správně fungovat.",
                linkedCategory: "necessary"
              },
              {
                title: "Analytika",
                description: "Povolením této volby nám pomáháte zlepšovat naše webové stránky a zároveň nás tím povzbudíte k další práci na jejich zlepšení.",
                linkedCategory: "analytics"
              },
              {
                title: "Personalizace podle vašeho chování",
                description: "Povolením této volby nám umožníte upravit obsah stránek a nabídnout vám produkty a služby, které by vás mohly zajímat na základě dříve navštívených stránek a produktů",
                linkedCategory: "marketing"
              },
              {
                title: "Rozšířený marketing",
                description: "Povolením této volby nám povolíte zobrazovat vám reklamu, která bude pro vás relevantnější a zajímavější. Součástí tohoto souhlasu je i sdílení vašich údajů s reklamními systémy a sociálními sítěmi pro reklamní účely.",
                linkedCategory: "extended_marketing"
              }
            ]
          }
        },
        en: {
          consentModal: {
            title: "Privacy settings on our website",
            description: "Our website uses cookies to help us improve our services, personalize ads, and analyze traffic. The following categories describe how cookies are used. For more information on how we use cookies, visit our <a href=\"/privacy-policy\">privacy policy</a> page.",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Accept only necessary",
            showPreferencesBtn: "Adjust settings",
            footer: "<a href=\"/privacy-policy\">Privacy Policy</a>"
          },
          preferencesModal: {
            title: "Privacy settings",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject optional",
            savePreferencesBtn: "Save settings",
            closeIconLabel: "Close dialog",
            serviceCounterLabel: "Service|Services",
            sections: [
              {
                title: "Necessary <span class=\"pm__badge\">Always on</span>",
                description: "This option includes cookies and other data that are necessary for the basic functions of the website to work properly.",
                linkedCategory: "necessary"
              },
              {
                title: "Analytics",
                description: "Enabling this option helps us improve our website and encourages us to continue working on its improvement.",
                linkedCategory: "analytics"
              },
              {
                title: "Behavioral personalization",
                description: "Enabling this option allows us to customize the content of the site and offer you products and services that may interest you based on previously visited pages and products.",
                linkedCategory: "marketing"
              },
              {
                title: "Extended marketing",
                description: "Enabling this option allows us to show you ads that are more relevant and interesting to you. This consent also includes sharing your data with advertising systems and social networks for advertising purposes.",
                linkedCategory: "extended_marketing"
              }
            ]
          }
        }
      }
    },
    disablePageInteraction: false,
    autoShow: false,
    revision: 0,
    onFirstConsent: ({cookie}) => {
      console.log('onFirstConsent fired', cookie);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'client-consent-update',
        'cookie_consent': cookie
      });
      saveConsent({data: cookie});
    },
    onConsent: ({cookie}) => {
      console.log('onConsent fired!', cookie);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'client-consent-update',
        'cookie_consent': cookie
      });
    },
    onChange: ({cookie, changedCategories, changedServices}) => {
      console.log('onChange fired!', changedCategories, changedServices);
      console.log('cookie:', cookie);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'client-consent-update',
        'cookie_consent': cookie
      });
      saveConsent({data: cookie});
    },
    onModalReady: ({modalName}) => {
      console.log('ready:', modalName);
    },
    onModalShow: ({modalName}) => {
      console.log('visible:', modalName);
    },
    onModalHide: ({modalName}) => {
      console.log('hidden:', modalName);
    },
  });

  setTimeout(CookieConsent.show, 3000);
};

const saveConsent = ({data}) => {
  data.domain = window.location.hostname;
  fetch(window.location.origin + '/index.php?aio=cookie-consent', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

document.addEventListener('DOMContentLoaded', function () {
    runCookieConsent();
});

window.CookieConsent = CookieConsent;

export { runCookieConsent, saveConsent, CookieConsent };